<script>
	import { _ } from 'svelte-i18n'
  import { handleUpsell } from '../modules/helpers'
	import { chosen_theme, user_valid, demos } from '../stores'
	import HorizontalOptionsList from '../elements/HorizontalOptionsList.svelte'

	let options = [{value: 'light', display:$_('app.day')}, {value: 'dark', display:$_('app.night')}, {value: 'auto', display:$_('app.auto')}]
	let demoing = false
	$: if ($demos) demoing = demos.valid('theme')
</script>

<div 
	class="wrapper" 
	class:pro_only={!$user_valid}
	class:demoing
	on:click={() => handleUpsell('theme')}>
	<HorizontalOptionsList list_options={options} bind:selected_option={$chosen_theme}/>
</div>

<style>
	.wrapper {
		position: relative;
    margin-right: 4rem;
  }
</style>
